import { useEffect, useRef } from "react";
import { useSearchParams, Link } from "react-router-dom";
import api from "@/lib/api";
import { XCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function PaymentCancel() {
  const [sp] = useSearchParams();
  const done = useRef(false);
  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const orderId = sp.get("order_id");
    if (orderId) api.post(`/payments/cancel/${orderId}`).catch(() => {});
  }, [sp]);
  return (
    <div className="max-w-lg mx-auto px-4 py-24 text-center" data-testid="payment-cancel-page">
      <XCircle className="w-14 h-14 text-terracotta mx-auto mb-4" />
      <h1 className="font-heading text-3xl text-forest">Payment Cancelled</h1>
      <p className="text-brown/70 mt-2">No charge was made. Your items are still in the cart.</p>
      <Link to="/cart"><Button className="mt-5 rounded-full bg-forest hover:bg-earth text-cream">Back to Cart</Button></Link>
    </div>
  );
}
